'use strict';

(function ($) {
  var methods = {
    init: function (options) {
      var opts = $.extend({}, $.fn.dateIntervalSelect.defaults, options);

      return this.each(function () {
        var _this = this;
        var $this = $(this);

        if ($this.hasClass('date-interval-select-init')) {
          return;
        }

        $this.addClass('date-interval-select-init');
        $this.on('change', function (/*e*/) {
          methods.select.apply(_this, [opts]);
        });
      });
    },

    select: function (opts) {
      var $this = $(this);

      var $option = $this.find('option:selected');
      var $wrapper = $(opts.selectorContainer);
      var $dateFrom = $wrapper.find(opts.selectorDateFrom);
      var $dateTo = $wrapper.find(opts.selectorDateTo);

      if (opts.prefillValue) {
        $dateFrom.val($option.data('date_from'));
        $dateTo.val($option.data('date_to'));
      }

      if (opts.disableInputs) {
        $dateFrom.prop('disabled', true);
        $dateTo.prop('disabled', true);
        if ($this.val() === 'custom') {
          $dateFrom.prop('disabled', false);
          $dateTo.prop('disabled', false);
        }
      }
    }
  };

  $.fn.dateIntervalSelect = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.dateIntervalSelect');
    }

  };

  $.fn.dateIntervalSelect.defaults = {
    selectorContainer: 'body',
    selectorDateFrom: '.date-interval-from',
    selectorDateTo: '.date-interval-to',
    preFillValue: true,
    disableInputs: true
  };

})(jQuery);
